
<div class="container workflow">
  <div class="row">
    <div class="col" style="height: 24px; overflow: hidden;"> </div>
  </div>
  <div class="row" *ngIf="!!error">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row" [hidden]="!!error">
    <div class="col page-title-container" style="height: 48px; overflow: hidden;">
      <h3 class="workflow-title" [hidden]="!workflowService.readableTargetName">{{ workflowService.readableTargetType }}: {{ workflowService.readableTargetName }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumb of workflowService.workflowConfig.breadcrumb"><a [routerLink]="['/' + breadcrumb.queryAction]" [queryParams]="breadcrumb.queryParams" title="{{breadcrumb.text}}">{{ breadcrumb.text | slice:0:13 }}{{breadcrumb.text.length > 13 ? ' ...' : ''}}</a></li>
      </ol>
      <md-spinner-block [hidden]="workflowService.readableTargetName"></md-spinner-block>
    </div>
  </div>
  <workflow-step-bar [hidden]="!workflowService.readableTargetName || !!error"></workflow-step-bar>
  <workflow-blocked-notice [hidden]="!workflowService.readableTargetName"></workflow-blocked-notice>
  <project-missing-roles [hidden]="!!error"></project-missing-roles>
  <order-rejection-message [hidden]="!!error"></order-rejection-message>
  <deployment-rejection-message [hidden]="!!error"></deployment-rejection-message>
  <order-acceptance-disable [hidden]="!!error"></order-acceptance-disable>
  <project-rejection-message [hidden]="!!error"></project-rejection-message>
  <div class="row" [hidden]="!workflowService.readableTargetName || !!error">
    <div class="col contains-workflow-router" [hidden]="workflowService.loading">
      <router-outlet></router-outlet>
    </div>
    <div class="col" [hidden]="!workflowService.loading">
      <md-spinner-block></md-spinner-block>
    </div>
  </div>
</div>